<template>
  <div>
    <router-link :to="{ name: 'login' }">
      <component :is="require('icons/Login').default" />
    </router-link>
  </div>
</template>

<script>
export default {
  name: "app_header_notlogged"
};
</script>

<style>
a {
  color: #606266;
  margin-left: 1rem;
}
</style>
